/* ============================================================
   IMENHOF BLOOM — variant-availability.js
   Legt beschikbaarheids-states op de variantkiezer:
   - niet-bestaande combinaties -> uitgeschakeld + grijs
   - uitverkochte combinaties    -> doorgestreept (blijft klikbaar)
   - veiligheidsnet: corrigeert een onmogelijke keuze automatisch
   Draait in de capture-fase, vóór theme.js' eigen update(),
   zodat prijs/knop daarna kloppen. Raakt theme.js niet aan.
   ============================================================ */
(function () {
  'use strict';

  function injectCSS() {
    if (document.getElementById('imh-va-css')) return;
    var css =
      '.variant-opt input:disabled+label{cursor:not-allowed}' +
      '.variant-opt.is-unavailable>label{opacity:.4}' +
      '.variant-opt.is-unavailable:not(.variant-opt--swatch)>label{text-decoration:line-through}' +
      '.variant-opt.is-soldout:not(.variant-opt--swatch)>label{text-decoration:line-through;opacity:.65}' +
      '.variant-opt--swatch.is-unavailable>label,.variant-opt--swatch.is-soldout>label{position:relative}' +
      '.variant-opt--swatch.is-unavailable>label::after,.variant-opt--swatch.is-soldout>label::after{' +
        'content:"";position:absolute;inset:0;border-radius:inherit;' +
        'background:linear-gradient(to top left,transparent calc(50% - 1px),var(--muted) calc(50% - 1px),var(--muted) calc(50% + 1px),transparent calc(50% + 1px))}';
    var s = document.createElement('style');
    s.id = 'imh-va-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function init(picker) {
    var json = picker.querySelector('[data-variants-json]');
    if (!json) return;
    var data;
    try { data = JSON.parse(json.textContent); } catch (e) { return; }
    if (!Array.isArray(data) || !data.length) return;

    var groups = Array.prototype.slice
      .call(picker.querySelectorAll('.variant-group'))
      .map(function (g) {
        var inputs = Array.prototype.slice.call(g.querySelectorAll('input[type=radio]'));
        var idx = inputs.length ? (parseInt(inputs[0].name.replace('option-', ''), 10) - 1) : 0;
        return { el: g, inputs: inputs, idx: idx };
      })
      .filter(function (g) { return g.inputs.length; });
    if (!groups.length) return;

    function selected() {
      var sel = [];
      groups.forEach(function (g) {
        var c = g.inputs.filter(function (i) { return i.checked; })[0];
        sel[g.idx] = c ? c.value : null;
      });
      return sel;
    }

    function matches(sel, gi, val) {
      return data.filter(function (v) {
        return v.options.every(function (o, idx) {
          if (idx === gi) return o === val;
          return sel[idx] == null || o === sel[idx];
        });
      });
    }

    function exactVariant(sel) {
      return data.filter(function (v) {
        return v.options.every(function (o, idx) { return o === sel[idx]; });
      })[0];
    }

    function refresh() {
      var sel = selected();
      groups.forEach(function (g) {
        g.inputs.forEach(function (input) {
          var m = matches(sel, g.idx, input.value);
          var existing = m.length > 0;
          var availExists = m.some(function (v) { return v.available; });
          var opt = input.closest('.variant-opt');
          input.disabled = (!existing) && !input.checked;
          if (opt) {
            opt.classList.toggle('is-unavailable', !existing);
            opt.classList.toggle('is-soldout', existing && !availExists);
          }
        });
      });
    }

    /* Alleen ingrijpen bij een NIET-BESTAANDE combinatie.
       Uitverkocht-maar-bestaand laten we staan (knop toont "Uitverkocht"). */
    function autofix(changed) {
      var sel = selected();
      if (exactVariant(sel)) return;
      if (!changed) return;
      var ci = parseInt(changed.name.replace('option-', ''), 10) - 1;
      var cand = data.filter(function (v) { return v.options[ci] === changed.value; });
      var pick = cand.filter(function (v) { return v.available; })[0] || cand[0];
      if (!pick) return;
      groups.forEach(function (g) {
        var want = pick.options[g.idx];
        var inp = g.inputs.filter(function (i) { return i.value === want; })[0];
        if (inp && !inp.checked) { inp.checked = true; }
      });
    }

    picker.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      autofix(t);
      refresh();
    }, true);

    refresh();
  }

  function boot() {
    var pickers = document.querySelectorAll('[data-variant-picker]');
    if (!pickers.length) return;
    injectCSS();
    pickers.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
